






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {AuditoriaMotivo} from '@/model/resource/AuditoriaMotivo'
import {InputAuditoriaMotivoSchema} from '@/schema/resource/AuditoriaMotivo/InputAuditoriaMotivoSchema'

@Component
export default class PersistAuditoriaMotivoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputAuditoriaMotivoSchema()
  auditoriaMotivo = new AuditoriaMotivo()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.auditoriaMotivo.getAuditoriaMotivo(id)
    }

    $.await.done('getAuditoriaMotivo')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.auditoriaMotivo.persistAuditoriaMotivo()
    await Helper.successAndPush(
      'system.success.persist',
      '/auditoria-motivo/list'
    )
  }
}
